<template>
    <div :class="getCSSClass('model-manager-component-wrapper-container')">
        <div :class="getCSSClass('model-manager-component-wrapper')">
            <component :is="subComponent"
                       v-if="!valuesetLoading"
                       v-bind="subComponentProps"
                       v-on:input="emitInputIfAllowed($event)"
                       v-model="subComponentValue"
                       :class="getCSSClass('model-manager-component-wrapper-subcomponent')"
            ></component>
            <button type="button" v-if="!autoEmit"
                    :class="getCSSClass('model-manager-component-wrapper-emit-button')"
                    v-on:click="emitInput(subComponentValue)"
                    v-html="translate('Kiválasztás')"></button>
            <button v-if="autoEmit" :class="getCSSClass('model-manager-component-add-button') + ' ' + getCSSClass('model-manager-component-add-button-singleline')"
                    type="button"
                    v-html="addButtonHTML"
                    v-on:click="showForm"
            ></button>
            <button v-if="updateUrl !== null && autoEmit" :class="getCSSClass('model-manager-component-edit-button') + ' ' + getCSSClass('model-manager-component-edit-button-singleline')"
                    type="button"
                    v-html="editButtonHTML"
                    v-on:click="showEditForm"
                    :disabled="!subComponentValue || subComponentValue == -1"
            ></button>

        </div>
        <div :class="getCSSClass('model-manager-component-wrapper-add-button-container')" v-if="!autoEmit">
            <button :class="getCSSClass('model-manager-component-add-button')"
                    type="button"
                    v-html="addButtonHTML"
                    v-on:click="showForm"
            ></button>
            <button v-if="updateUrl !== null" :class="getCSSClass('model-manager-component-edit-button')"
                    type="button"
                    v-html="editButtonHTML"
                    v-on:click="showEditForm"
                    :disabled="!subComponentValue || subComponentValue == -1"
            ></button>
        </div>
        <popup :visible="showPopup"
               :show-close-button="false">
            <edit-form
                    v-if="showPopup"
                    v-bind:data-url="formUrl"
                    v-bind:save-url="storeUrl"
                    v-bind:ajax-operations-url="formAjaxOperationsUrl"
                    v-on:submit-success="hideFormAndSelect($event)"
                    v-on:editing-canceled="hideForm"
                    redirect-to-response-on-success="false"
                    :buttons="mainButtons"
            ></edit-form>
        </popup>
        <popup :visible="showEditPopup"
               :show-close-button="false">
            <edit-form
                    v-if="showEditPopup"
                    v-bind:data-url="actualEditUrL"
                    v-bind:save-url="actualUpdateUrL"
                    v-bind:ajax-operations-url="formAjaxOperationsUrl"
                    v-on:submit-success="hideFormAndSelect($event)"
                    v-on:editing-canceled="hideForm"
                    redirect-to-response-on-success="false"
                    :buttons="mainButtons"
            ></edit-form>
        </popup>
    </div>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon', 'mainButtons'],
        props: {
            subComponent: {type: String},
            defaultSubComponentProps: {type: Object},
            subComponentValuesetProp: {type: String},
            addButtonHTML: {type: String, default: '+'},
            editButtonHTML: {type: String, default: '<i class="far fa-pencil"></i>'},
            formUrl: {type: String},
            storeUrl: {type: String},
            editUrl: {type: String, default: null},
            updateUrl: {type: String, default: null},
            formAjaxOperationsUrl: {type: String, default: ''},
            fetchUrl: {type: String},
            value: {},
            buttons: {type: Object},
            exceptIds: {type: Array, default: () => {return []}},
            autoEmit: {type: Boolean, default: false},
            clearAfterAdding: {type: Boolean, default: true}
        },
        data: function() {
            return {
                showPopup: false,
                showEditPopup: false,
                subComponentProps: {},
                subComponentValue: null,
                valuesetLoading: true,
            }
        },
        methods: {
            emitInputIfAllowed: function(payload) {
                if (!this.autoEmit) {
                    return;
                }
                this.emitInput(payload);
            },
            emitInput: function(payload) {
                this.$emit('input', payload);
                if (this.clearAfterAdding) {
                    this.subComponentValue = -1;
                }
            },
            fetchValueset: function(callback) {
                window.axios.get(this.fetchUrl)
                    .then((response) => {
                        this.$set(this.subComponentProps, this.subComponentValuesetProp, response.data)
                        this.$emit('valueset', this.subComponentProps[this.subComponentValuesetProp]);
                        this.valuesetLoading = false;
                        if (typeof(callback) != 'undefined') {
                            callback(response.data);
                        }
                    })
            },
            showForm: function() {
                this.showPopup = true;
            },
            showEditForm: function() {
                this.showEditPopup = true;
            },
            hideFormAndSelect: function(subject) {
                this.fetchValueset(() => {
                    Vue.set(this, 'subComponentValue', subject.id);
                    this.emitInputIfAllowed(subject.id);
                });
                this.hideForm();
            },
            hideForm: function() {
                //this.fetchValueset();
                this.showPopup = false;
                this.showEditPopup = false;
            },
        },
        created() {
            this.$set(this, 'subComponentValue', this.value);
            this.subComponentProps = JSON.parse(JSON.stringify(this.defaultSubComponentProps));
            this.$set(this.subComponentProps, 'exceptIds', this.exceptIds);
        },
        mounted() {
            this.fetchValueset();
        },
        computed: {
            actualUpdateUrL: function() {
                if (!this.updateUrl) {
                    return null;
                }
                if (!this.subComponentValue) {
                    return null;
                }
                let value = this.subComponentValue['id'] ? this.subComponentValue['id'] : this.subComponentValue;
                return this.updateUrl.toString().replace('__id__', value);
            },
            actualEditUrL: function() {
                if (!this.editUrl) {
                    return null;
                }
                if (!this.subComponentValue) {
                    return null;
                }
                let value = this.subComponentValue['id'] ? this.subComponentValue['id'] : this.subComponentValue;
                return this.editUrl.toString().replace('__id__', value);
            }
        },
        watch: {
            exceptIds: function() {
                this.$set(this.subComponentProps, 'exceptIds', this.exceptIds);
            },
            fetchUrl: function() {
                this.fetchValueset();
            },
            value: function(value) {
                Vue.set(this, 'subComponentValue', value);
            }
        }
    }
</script>